// Staples are shelf-stable basics the user CONFIRMS they keep (onboarding / Me). They count as
// owned for matching; they are never inferred from a photo.

import type { IngredientId } from './taxonomy';

/** Offered during onboarding; the common ones are pre-selected for one-tap confirmation. */
export const STAPLE_CHOICES: IngredientId[] = [
  'salt', 'black_pepper', 'cooking_oil', 'olive_oil', 'sugar', 'flour', 'garlic', 'onion',
  'soy_sauce', 'vinegar', 'butter', 'rice', 'pasta', 'baking_powder', 'cornstarch',
  'cumin', 'paprika', 'oregano', 'chili_flakes', 'cinnamon', 'curry_powder', 'thyme',
  'honey', 'tomato_paste', 'mustard', 'mayonnaise', 'ketchup', 'vegetable_broth',
];

export const DEFAULT_STAPLES: IngredientId[] = [
  'salt', 'black_pepper', 'cooking_oil', 'olive_oil', 'sugar', 'flour', 'garlic', 'onion',
];
